var PrintOrientations = /* @__PURE__ */ ((PrintOrientations2) => {
  PrintOrientations2["LANDSCAPE"] = "landscape";
  PrintOrientations2["PORTRAIT"] = "portrait";
  return PrintOrientations2;
})(PrintOrientations || {});

export { PrintOrientations };
//# sourceMappingURL=PrintOrientations.js.map
